<template>
    <div>
        <vs-popup :title="$t('edit_time_appointment')" :active.sync="model">
            <div class="flex justify-between items-center">
                <!-- Пред неделя -->
                <vs-button
                    icon="keyboard_arrow_left"
                    type="border"
                    @click="setDate('prev')"
                    >{{ $t("prev-week") }}</vs-button
                >
                <span class="text-xl">{{ beginDate }}</span>

                <vs-button
                    icon-after
                    type="border"
                    icon="keyboard_arrow_right"
                    @click="setDate('next')"
                    >{{ $t("next-week") }}</vs-button
                >
            </div>
<!--            <vs-checkbox-->
<!--                @change="repeatStart"-->
<!--                class="mt-4"-->
<!--                v-model="specialistInfo.is_repeat"-->
<!--                >{{ $t("repeat_week") }}</vs-checkbox-->
<!--            >-->
            <!-- Дни недели с датами -->
            <div class="mt-6" v-if="week.length > 0">
                <div
                    :class="wMobile ? 'flex-col' : ''"
                    class="flex justify-between"
                >
                    <div class="ml-2" v-for="day in week" :key="day.uid">
                        <vs-radio v-model="selectDay" :vs-value="day.code - 1"
                            ><div class="flex flex-col">
                                <span style="text-align: center">{{
                                    day["name_" + $i18n.locale]
                                }}</span>
                                <span style="text-align: center" class="mt-2">{{
                                    day.date
                                }}</span>
                            </div>
                        </vs-radio>
                    </div>
                </div>
                <!-- Сами инпуты с датами -->
                <div class="mt-8">
                    <div
                        class="mt-4"
                        v-for="(item, i) in week[selectDay].dayofweek"
                        :key="i"
                    >
                        <div class="flex justify-between mt-2">
                            <!-- Время начла -->
                            <flat-pickr
                                :config="configdateTimePicker"
                                class="w-1/2"
                                v-model="item.start_time"
                                :placeholder="$t('start_consultation')"
                                @on-close="changeItem(item)"
                            />
                            <!-- Конец -->
                            <flat-pickr
                                :config="configdateTimePicker"
                                v-model="item.end_time"
                                class="w-1/2 ml-2"
                                @on-close="changeItem(item)"
                                :placeholder="$t('end_consultation')"
                            />
                            <!-- Удалить запись -->
                            <vs-button
                                color="danger"
                                class="ml-2"
                                @click="deleteItem(item)"
                                type="border"
                                icon-pack="feather"
                                icon="icon-trash"
                            >
                            </vs-button>
                        </div>
                    </div>
                </div>
                <!-- Добавить запись -->
                <div>
                    <vs-button
                        @click="add()"
                        class="mt-4"
                        type="border"
                        icon-pack="feather"
                        icon="icon-plus"
                        >{{ $t("add") }}</vs-button
                    >
                </div>

                <!-- Сохранить все -->
                <div class="flex justify-end">
                    <vs-button @click="saveEdit()" class="mt-4" icon="save">{{
                        $t("save")
                    }}</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    props: {
        value: [Boolean],
        specialist: [String],
    },
    components: {},
    data() {
        return {
            week: [],
            weekCopy: [],
            selectDay: 0,
            weekDays: [],
            dataEditItems: [],
            typeCopy: false,
            copyWeekDays: [],
            specialistInfo: {},
            configdateTimePicker: {
                enableTime: true,
                enableSeconds: false,
                noCalendar: true,
                time_24hr: true,
            },
            beginDate: this.$moment().format("DD.MM.YYYY"),
        };
    },
    async created() {
        this.getInfo();
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    watch: {
        beginDate() {
            this.getInfo();
        },
    },
    methods: {
        async repeatStart() {
            const res = await this.$http.patch(
                "specialists/specialist-cv/mark/",
                [
                    {
                        uid: this.specialist,
                    },
                ]
            );
        },
        // Получении уже доступных записей
        async getInfo() {
            if (this.specialist !== undefined) {
                this.$vs.loading();
                const res = await this.$http(
                    `specialists/specialist-appointment/?begin_date=${ this.beginDate }&type=${ this.specialist }`
                );
                const data = await this.$http(
                    `specialists/specialist-cv/${ this.specialist }/`
                );
                this.specialistInfo = data.data;
                this.week = res.data;
                this.weekCopy = res.data;
                this.$vs.loading.close();
            }
        },
        // Изменение даты для пагинации
        setDate(da) {
            if (da === "prev") {
                this.beginDate = this.$moment(
                    this.beginDate.replace(/(\d+).(\d+).(\d+)/, "$3/$2/$1")
                )
                    .subtract(7, "days")
                    .format("DD.MM.YYYY");
            } else {
                this.beginDate = this.$moment(
                    this.beginDate.replace(/(\d+).(\d+).(\d+)/, "$3/$2/$1")
                )
                    .add(7, "days")
                    .format("DD.MM.YYYY");
            }
        },
        // Сохранение изменений
        async saveEdit() {
            let data = [];

            this.week.forEach((item) => {
                item.dayofweek.forEach((el) => {
                    if (el.new && el.start_time !== "" && el.end_time !== "") {
                        data.push(el);
                    }
                });
            });
            // Если есть измененные ячейки вызывается метод
            if (this.dataEditItems.length > 0) {
                this.putItems();
            }
            // Сохранение новых
            if (data.length > 0) {
                try {
                    const res = await this.$http.post(
                        "specialists/specialist-appointment/",
                        data
                    );
                    if (res !== undefined && res.status === 201) {
                        this.$vs.notify({
                            title: this.$t("success_save"),
                            color: "success",
                        });
                    }
                } catch (e) {
                    this.$vs.notify({
                        text: e["message_" + this.$i18n.locale],
                        color: "danger",
                    });
                }

                this.getInfo();
            }
        },
        // Копирование расписания
        copyWeek() {
            this.copyWeekDays = this.week;
            this.typeCopy = true;
        },
        // Вставка расписания
        pastWeek() {
            this.week = this.copyWeekDays.map((item) => {
                const date = this.week.find((elem) => elem.code === item.code);
                // Проходим по элемнтам внутри даты и добавляем ключь new
                let dayof = item.dayofweek.map((el) => {
                    return {
                        start_time: el.start_time,
                        end_time: el.end_time,
                        new: true,
                        date: date.date,
                        specialist: el.specialist.uid,
                        key: Math.random(999),
                    };
                });
                // проходим по дням и изменяем дату и элементы
                return {
                    dayofweek: dayof,
                    uid: item.uid,
                    code: item.code,
                    date: date.date,
                    specialist: item.specialist,
                    name: item.name,
                };
            });

            this.typeCopy = false;
        },
        // Вызывается при изменении в инпуте для записи в массив изменения
        changeItem(item) {
            if (item.uid) {
                const index = this.dataEditItems.findIndex(
                    (el) => el.uid === item.uid
                );
                if (index === -1) {
                    this.dataEditItems.push({
                        uid: item.uid,
                        start_time: item.start_time,
                        end_time: item.end_time,
                        specialist: this.specialist,
                        date: item.date,
                    });
                } else {
                    this.dataEditItems[index] = {
                        uid: item.uid,
                        start_time: item.start_time,
                        end_time: item.end_time,
                        specialist: this.specialist,
                        date: item.date,
                    };
                }
            }
        },
        // Запрос на изменения
        async putItems() {
            this.$vs.loading();
            setTimeout(async () => {
                try {
                    const res = await this.$http.put(
                        "specialists/specialist-appointment/put/",
                        this.dataEditItems
                    );
                    if (res.status === 200) {
                        this.$vs.notify({
                            title: this.$t("success_save"),
                            color: "success",
                        });
                    }
                } catch (e) {
                    this.$vs.notify({
                        title: this.$t("error"),
                        text: e["message_" + this.$i18n.locale],
                        color: "danger",
                    });
                }
                this.$vs.loading.close();
            }, 2000);
        },
        add() {
            // Добавляем новое время

            this.week[this.selectDay].dayofweek.push({
                start_time: "",
                end_time: "",
                new: true,
                date: this.$moment(
                    this.week[this.selectDay].date.replace(
                        /(\d+).(\d+).(\d+)/,
                        "$3/$2/$1"
                    )
                ).format("DD.MM.YYYY"),
                specialist: this.specialist,
                key: Math.random(999),
            });
        },
        // Удалить время
        async deleteItem(elem) {
            // this.$vs.loading();
            if (elem.uid) {
                const res = await this.$http.delete(
                    `specialists/specialist-appointment/delete/${ elem.uid }/`
                );
                if (res.status === 204) {
                    const index = this.week[this.selectDay].dayofweek.findIndex(
                        (item) => item.uid === elem.uid
                    );
                    this.week[this.selectDay].dayofweek.splice(index, 1);
                }
            } else {
                const index = this.week[this.selectDay].dayofweek.findIndex(
                    (item) => item.key === elem.key
                );
                this.week[this.selectDay].dayofweek.splice(index, 1);
            }
            // this.$vs.loading.close();
        },
    },
};
</script>

<style>
.vs-popup {
    width: 800px !important;
}
</style>
